import Icon from "assets/icons";
import { Link } from "react-router-dom";
import { useCopies } from "shared/hooks/useCopies";

function PageNotFound(props: { homePath?: string }) {
  const copies = useCopies();
  return (
    <div className="pageNotFound_wrapper">
      <div className="pageNotFound_content_wrapper">
        <span className="pageNotFound_icon">
          <Icon.BrokenLink />
        </span>
        <div className="pageNotFound_content">
          <b>{copies.get("oops")}</b>
          <span>{copies.get("page.not.found.message")}</span>
          <Link to={props.homePath || "/"} title={copies.get("back.to.home")}>
            <span>{copies.get("back.to.home")}</span>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default PageNotFound;
